const READ_ALOUD_WIDTH = 90

export function activeHeaders({ hasClassroomProvider, showReadAloud = false, }: { hasClassroomProvider: boolean, showReadAloud?: boolean }) {
  const name = {
    width: '204px',
    name: 'Name',
    attribute: 'name',
    rowSectionClassName: 'student-name border-right',
    renderCellsAsHeaders: true
  }

  const usernameOrEmail = {
    width: `${(hasClassroomProvider ? 264 : 334) - (showReadAloud ? READ_ALOUD_WIDTH : 0)}px`,
    name: 'Username/Email',
    attribute: 'usernameOrEmail',
    rowSectionClassName: hasClassroomProvider ? 'username-or-email' : 'username-or-email wide'
  }

  const logInMethod = {
    width: '139px',
    name: 'Log-in Method',
    attribute: 'logInMethod',
    rowSectionClassName: 'login-method'
  }

  const lastActive = {
    width: '130px',
    name: 'Last Active',
    attribute: 'lastActive',
  }

  const activities = {
    width: '109px',
    name: 'Activities',
    attribute: 'activities',
    rowSectionClassName: 'left-align'
  }

  const readAloud = {
    width: `${READ_ALOUD_WIDTH}px`,
    name: 'Read Aloud',
    attribute: 'readAloud',
    rowSectionClassName: 'left-align',
    noTooltip: true
  }

  const synced = {
    width: '94px',
    name: 'Synced',
    attribute: 'synced',
    rowSectionClassName: 'tooltip-section',
    noTooltip: true,
    containsOwnTooltip: true
  }

  const actions = {
    name: 'Actions',
    attribute: 'actions',
    isActions: true
  }

  const headers = [name, usernameOrEmail, logInMethod, lastActive, activities]
  if (showReadAloud) { headers.push(readAloud) }
  if (hasClassroomProvider) { headers.push(synced) }
  headers.push(actions)

  return headers
}

export function archivedHeaders(hasClassroomProvider: boolean) {
  const name = {
    width: '259px',
    name: 'Name',
    attribute: 'name',
    rowSectionClassName: 'student-name border-right',
    renderCellsAsHeaders: true
  }

  const usernameOrEmail = {
    width: hasClassroomProvider ? '431px' : '555px',
    name: 'Username/Email',
    attribute: 'usernameOrEmail'
  }

  const synced = {
    width: '148px',
    name: 'Synced',
    attribute: 'synced',
    rowSectionClassName: 'tooltip-section',
    noTooltip: true,
    containsOwnTooltip: true
  }

  return hasClassroomProvider
    ? [name, usernameOrEmail, synced]
    : [name, usernameOrEmail]
}
